// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"414759ef","453":"c988d4b6","501":"49320f82","996":"27788920"}[chunkId] + ".chunk.js";
};